<template>
  <div class="flex items-center flex-col justify-center min-h-screen sans-serif">
    <div class="w-full max-w-xs">
      <form v-if="passwordSessionValid" class="bg-white shadow-md rounded-lg pt-4 pb-8 mb-4 relative" id="login"
            v-on:submit.prevent="submitNewPassword">
        <div class="absolute badge-position">
          <span class="text-white rounded-full bg-blue-light px-4 py-2">
            Aggregator
          </span>
        </div>
        <div class="px-8 pt-4">
          <div class="text-center">
            <Logo></Logo>
          </div>
          <h1 class="py-4 text-2xl text-navy text-center font-semibold">Hey {{ aggregatorName }}</h1>
          <h3 class="py-4 text-navy text-center font-semibold">Choose your new password</h3>
        </div>
        <div class="mt-4 bg-green px-8 py-3" v-if="passwordSuccess">
          <p class="text-sm text-white text-bold">Your password has been updated!</p>
        </div>
        <div class="mb-4 px-8">
          <label class="label">
            New Password
          </label>
          <input class="appearance-none border rounded w-full py-4 px-3 text-navy" v-model="password" id="password"
                 name="password" type="password" placeholder="Password"
                 v-validate="{required: true, regex: '^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z]).{8,}$' }"
                 :class="{'border-red': errors.has('password') }">
          <p class="text-red text-xs italic mt-2" v-show="errors.has('password')">Your password is weak, please enter at
            least 1 lower and upper case letter and 1 number with a minimum of 8 characters.</p>
        </div>
        <div class="mb-4 px-8">
          <label class="label">
            Repeat New Password
          </label>
          <input class="appearance-none border rounded w-full py-4 px-3 text-navy" v-model="repeatPassword"
                 id="repeat-password" name="repeat-password" type="password" placeholder="Repeat Password"
                 v-validate="'required|confirmed:password'" :class="{'border-red': errors.has('repeat-password') }">
          <p class="text-grey text-xs italic mt-2">Password must have at least 1 lower and upper case letter, 1 number,
            and have a minimum of 8 characters</p>
          <p class="text-red text-xs italic mt-2" v-show="errors.has('repeat-password')">Password Doesn't Match</p>
        </div>
        <div class="flex px-8 mt-3">
          <input type="submit" value="Send"
                 class="bg-green hover:opacity-75 text-white font-bold py-3 px-4 rounded w-full text-lg">
        </div>
      </form>
      <div class="mt-4 bg-red px-8 py-3" v-if="!passwordSessionValid">
        <p class="text-sm text-white text-bold">This Link is Expired!</p>
      </div>
    </div>
    <div class="border-t border-grey-lightest mt-8">
      <BrokerFooter></BrokerFooter>
    </div>
  </div>
</template>

<script>
import Logo from '@/assets/Logo';
import BrokerFooter from '@/components/BrokerFooter';

export default {
  name: 'AggregatorNewPassword',
  metaInfo: {
    title: 'New Password | SocietyOne Personal Loans',
  },
  $_veeValidate: {
    validator: 'new',
  },
  components: {Logo, BrokerFooter},
  created() {
    this.fetchAggregatorDetails();
  },
  data() {
    return {
      password: '',
      repeatPassword: '',
      passwordSuccess: false,
      passwordSessionValid: true,
      forgotPasswordId: '',
      aggregatorId: '',
      aggregatorName: '',
    };
  },
  methods: {
    async fetchAggregatorDetails() {
      try {
        const forgotPasswordId = this.$route.params.id;
        this.forgotPasswordId = forgotPasswordId;
        const data = await this.$http.get(`aggregator/new-password?id=${forgotPasswordId}`)
        // set state variables
        const {body} = data;
        this.aggregatorId = body.aggregatorId;
        this.aggregatorName = body.aggregatorName;
      } catch (e) {
        this.$toasted.error(`Error: ${(e.body && e.body.error) || e.message || 'Could not get forgot password'}`)
        this.passwordSessionValid = false;
      }
    },
    async submitNewPassword() {
      const validate = await this.$validator.validateAll();
      const vm = this;
      if (validate) {
        try {
          await this.$http.post('aggregator/new-password', {
            newPassword: this.password,
            aggregatorId: this.aggregatorId,
            forgotPasswordId: this.forgotPasswordId,
          })
          // set success state
          this.passwordSuccess = true;
          setTimeout(() => vm.$router.push('/aggregator/sign-in'), 500)
        } catch (e) {
          this.$toasted.error(`Error: ${(e.body && e.body.error) || e.message || 'Could not submit new password'}`)
        }
      }
    },
  },
};
</script>

<style scoped>
.badge-position {
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/Aggregator/AggregatorNewPassword.vue